import type { BuyerCost } from 'c-sdk';

type Cost = Pick<BuyerCost, 'cost' | 'days' | 'max_cost'> | null | undefined;

/**
 * A line item's price for a number of days under the buyer's latest cost: every started block of
 * `buyerCost.days` days costs `buyerCost.cost`. No buyer cost means no price. Extracted from
 * `useCampaignLineItemCost`.
 */
export const lineItemCost = (days: number, buyerCost: Cost) => {
    if (buyerCost) {
        return Math.ceil(days / buyerCost.days) * buyerCost.cost;
    }

    return 0;
};

/**
 * The summed price of several line items, each for its own days (the form's `days` field) or the
 * whole campaign, and that total capped at the buyer's `max_cost`.
 */
export const lineItemsTotalCost = (
    ids: Array<number | string>,
    days: Record<string, number> | null | undefined,
    defaultDays: number,
    buyerCost: Cost,
) => {
    const total = ids.reduce<number>(
        (runningTotal, lineItemId) =>
            runningTotal + lineItemCost(days?.[lineItemId] ?? defaultDays, buyerCost),
        0,
    );

    return { total, capped: Math.min(buyerCost?.max_cost ?? 0, total) };
};
